import classNames from "classnames";
import barcode12345678 from "../../assets/nobarcodeplaceholder.svg";
import barcodedynamic from "../../assets/nobarcodedynamic.svg";
import { BarcodeNode, NodeStates } from "../../build/types";
import { BuilderComponentProps } from "../BuilderInterface";
import { getCompoundStyle, getStateStyleForBuilder, getStylesFromInteractiveStates } from "../helpers";
import "./style.scss";
import { useInteractionStates } from "../../hooks/useInteractionStates";

const BuilderBarcode: React.FC<BuilderComponentProps> = ({
    node,
    actionCallbacks,
    dynamicData,
    builderProps,
    disabled
}: BuilderComponentProps) => {
    const { attr, svg, stateManager } = node as BarcodeNode;
    const { setElement, states } = useInteractionStates<HTMLDivElement>();
    const Placeholder = node.dynamicData ? barcodedynamic : barcode12345678;

    const classes = classNames("builder-barcode", {
        [`${attr?.className}`]: !!attr?.className
    });

    if (builderProps) {
        const { selectedMenu, nodeState, selectCallback, outlineCallback, onDragStart, onDragEnd } = builderProps;

        const wrapperStyle = getCompoundStyle({
            node,
            stateStyle: getStateStyleForBuilder(stateManager, nodeState, "attr_style")
        });

        return (
            <>
                {node.dynamicData !== undefined && !dynamicData ? null : (
                    <div
                        {...attr}
                        {...actionCallbacks}
                        className={classes}
                        style={wrapperStyle}
                        onClick={e => (selectCallback ? selectCallback(e, node.id) : {})}
                        onMouseMove={e => (outlineCallback ? outlineCallback(e, node.id) : {})}
                        id={node.id}
                        onDragStart={e => onDragStart?.(e, node.id)}
                        draggable={"true"}
                        onDragEnd={onDragEnd}
                    >
                        <img
                            src={svg ? `data:image/svg+xml;base64,${btoa(svg)}` : Placeholder}
                            draggable={"false"}
                            style={{ width: "100%", height: "100%", objectFit: "contain" }}
                        />
                        {selectedMenu}
                    </div>
                )}
            </>
        );
    } else {
        const barcodeStyle = getStylesFromInteractiveStates({
            states,
            defaultStyle: getCompoundStyle({ node }),
            stateManager,
            paths: ["attr_style"],
            ...(disabled ? { extraStates: [NodeStates.DISABLED] } : {})
        });

        return (
            <>
                {node.dynamicData !== undefined && !node.dynamicData ? null : (
                    <div ref={setElement} {...attr} {...actionCallbacks} className={classes} style={barcodeStyle}>
                        {svg && (
                            <img src={svg} draggable={"false"} style={{ width: "100%", height: "100%", objectFit: "contain" }} />
                        )}
                    </div>
                )}
            </>
        );
    }
};

export default BuilderBarcode;
